/**
 * Created by yqr on 2018/3/26.
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  collapsed: false,
  topNavState: 'home',
  leftNavState: 'home'
}

/*从本地存储读取数据*/
for(const item in state) {
  sessionStorage.getItem(item)? state[item] = JSON.parse(sessionStorage.getItem(item)): false;
}

export default new Vuex.Store({
  state
})



// WEBPACK FOOTER //
// ./src/store.js